import { apiFetcher } from "@/api/api"
import { useCacheSWR } from "@/api/swrCache"
import useSWRMutation from 'swr/mutation'


export function useFeedbackConfig() {
  const fetcher = () => {
    return apiFetcher(
      {
        path: '/site/api/v1/user/feedback/querySiteDepositRewardConfigList',
        type: 'post'
      },
      {}
    )
  }
  const result = useCacheSWR('useFeedbackConfig', fetcher, {
    dedupingInterval: 60 * 60 * 1000
  })
  const data = result.data?.data
  return {
    ...result,
    data: data
  }
}

//获取订单
export function useOrderList(category) {
  const fetcherFuc = () => {
    return apiFetcher(
      {
        path: '/site/api/v1/user/feedback/queryMemberBetList',
        type: 'post'
      },
      {
        arg: {
          category
        }
      }
    )
  }
  const result = useCacheSWR('useOrderList' + category, !!category ? fetcherFuc : null, {
    dedupingInterval: 10 * 1000,
    author: true
  })
  const list = result?.data?.data
  return {
    ...result,
    list
  }
}

//添加意见反馈
export function useAddFeedBack() {
  const params = {
    path: '/site/api/v1/user/feedback/addFeedBack',
    type: 'post'
  }
  return useSWRMutation(params, (params, arg: { arg: any }) => {
    return apiFetcher<any>(params, { ...arg })
  })
}
